<!-- Container-fluid starts-->
<div class="container-fluid">
  <app-row-progress [progress]="ordersStatics"></app-row-progress>

  <app-row-products></app-row-products>
  <app-row-ranking></app-row-ranking>
  <app-modal></app-modal>
</div>
<!-- Container-fluid Ends-->
